import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import NewNav from '../../layout/NewNav';


const DrawerButton = () => {
    const [visible, setVisible] = useState(false);

    const toggleDrawer = () => {
        setVisible(!visible);
    };

    return (
        <div>
            <Button
                icon="pi pi-bars"
                onClick={toggleDrawer}
                className="p-button-primary"
                aria-label="Menu"
                outlined
            />

            <div className="card flex justify-content-center">
            <Sidebar visible={visible} onHide={() => setVisible(false)} className="w-9">
            <NewNav />
            </Sidebar>
            </div>
            
        </div>
    );
};

export default DrawerButton;
